import { storeCreator } from '@/utils/store/store.utils';
  
  
interface State {
  isPlaidLoading: boolean;
  errorModal: boolean;
  successModal: boolean;
  setIsPlaidLoading: (value: boolean) => void;
  setErrorModal: (value: boolean) => void;
  setSuccessModal: (value: boolean) => void;
  handleReset: () => void;
}
  
export const useStore = storeCreator<State>((set) => ({
  isPlaidLoading: false,
  errorModal: false,
  successModal: false,

  setIsPlaidLoading: (value) => set((state) => ({ ...state, isPlaidLoading: value })),
  setErrorModal: (value) => set((state) => ({ ...state, errorModal: value })),
  setSuccessModal: (value) => set((state) => ({ ...state, successModal: value })),
  handleReset: () => set(() => ({ isPlaidLoading: false, errorModal: false, successModal: false })),
}));
  